<template>
  <div>
    <a-button :loading="loading" type="primary" @click="showDialog">同意</a-button>

    <a-modal
      :confirmLoading="loading"
      v-model:visible="visible"
      title="添加审批意见"
      @ok="handleOk"
    >
      <div class="approval-dialog__subtitle">当前操作：同意</div>
      <a-textarea
        show-count
        v-model:value="approvalContent"
        placeholder="请输入审批意见，最多200字"
        :auto-size="{ minRows: 3 }"
        :maxlength="200"
        allowClear
      />
    </a-modal>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from "vue";
import { ApprovalFlowService } from "../approval-flow.service";
import { message } from "ant-design-vue";
import { useFlowEmitter } from "@/utils/emitter";
export default defineComponent({
  name: "submit-approval-btn",
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const { emitEvent } = useFlowEmitter();
    const state = reactive({
      visible: false,
      approvalContent: "",
    });
    const showDialog = () => {
      state.approvalContent = "";
      state.visible = true;
    };
    const { run } = ApprovalFlowService.useAgreeApi();
    const handleOk = async () => {
      try {
        emit("update:loading", true);
        const { bizId, bizType } = props;
        const data = {
          bizId,
          bizType,
          remark: state.approvalContent,
        };
        let res = await run(data);
        if (res.respCode !== "0000") {
          // message.error(res.respDesc);
          return;
        }
        message.success(res.respDesc);
        emit("refresh", null);
        state.visible = false;
        emitEvent(bizId);
      } finally {
        emit("update:loading", false);
      }
    };
    return {
      ...toRefs(state),
      showDialog,
      handleOk,
    };
  },
});
</script>

<style scoped>
.approval-dialog__subtitle {
  color: #6d6d6d;
  position: absolute;
  top: 16px;
  left: 128px;
  font-size: 14px;
}
</style>
